(() => {
  const main = document.querySelector('#MainContent[data-template="search"]');
  if (!main) return;
  document.getElementById('filters-drawer')?.setAttribute('data-modal', '');
  main.addEventListener('click', event => {
    const reset = event.target.closest('.search__reset-button');
    if (!reset) return;
    const input = reset.closest('form')?.querySelector('input[name="q"]');
    if (!input) return;
    event.preventDefault(); input.value = ''; input.focus();
  });
  const results = main.querySelector('results-list');
  const count = main.querySelector('[data-bv-search-total]');
  if (!results) return;
  let source;
  const copyStyle = (from, to, onlyCardVariables = false) => {
    if (!from || !to) return;
    for (const name of from.style) {
      if (onlyCardVariables && !name.startsWith('--bv-card-')) continue;
      to.style.setProperty(name, from.style.getPropertyValue(name), from.style.getPropertyPriority(name));
    }
  };
  const apply = () => {
    const value = results.querySelector('[data-bv-search-count]')?.textContent.trim();
    if (count && value !== undefined && count.textContent !== value) count.textContent = value;
    if (!source) return;
    const heading = document.getElementById('filters-drawer-heading');
    const headingText = heading && [...heading.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    if (headingText && source.heading && headingText.textContent.trim() !== source.heading) headingText.textContent = source.heading;
    const shown = results.querySelector('[data-bv-search-shown]');
    if (shown) shown.hidden = source.buttons.bv_filter_count_visible === false;
    results.querySelectorAll('product-card').forEach(card => {
      copyStyle(source.card, card, true);
      for (const selector of ['.bv-card-layout', '.card-gallery', '.text-block', 'product-price']) {
        copyStyle(source.card.querySelector(selector), card.querySelector(selector));
      }
      for (const selector of ['.bv-card-review-average', '.bv-card-review-count']) {
        const show = selector.endsWith('average') ? source.settings.bv_card_score_show : source.settings.bv_card_count_show;
        card.querySelectorAll(selector).forEach(node => { node.hidden = show === false; });
      }
      card.querySelectorAll('quick-add-component').forEach(node => { node.hidden = source.buttons.bv_catalog_add === false; });
      if (source.label) {
        const button = card.querySelector('.quick-add__button--add');
        const text = button && [...button.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (text && text.textContent.trim() !== source.label) text.textContent = source.label;
      }
    });
    results.dataset.bvCardSynced = 'true';
  };
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; apply(); });
  }).observe(results, {childList: true, subtree: true});
  apply();
  // Liquid cannot read another template's block settings. Read their public,
  // current rendering once per search page; keep actual search products intact.
  const url = new URL(results.dataset.bvCardSource, location.origin);
  const preview = new URL(location.href).searchParams.get('preview_theme_id');
  if (preview) url.searchParams.set('preview_theme_id', preview);
  fetch(url, {credentials:'same-origin', cache:'no-store'})
    .then(response => { if (!response.ok) throw new Error('Collection card source unavailable'); return response.text(); })
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const settings = doc.querySelector('[data-bv-collection-card-source]');
      const buttons = doc.querySelector('[data-bv-collection-button-source]');
      const card = doc.querySelector('#MainContent product-card');
      if (!settings || !buttons || !card) return;
      const button = card.querySelector('.quick-add__button--add');
      const label = button && [...button.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent.trim()).join(' ').trim();
      const sourceLayout = doc.querySelector('[id^="bv-collection-layout-"]');
      if (sourceLayout) {
        const css = [...doc.querySelectorAll('style')].filter(node => /bv-filter-toolbar|bv-toolbar-sort|bv-collection-products-count|#filters-drawer/.test(node.textContent)).map(node => node.textContent.replaceAll(sourceLayout.id, results.id)).join('\n');
        let style = document.getElementById('BvSearchCollectionToolbarStyle');
        if (!style) { style = document.createElement('style'); style.id = 'BvSearchCollectionToolbarStyle'; document.head.append(style); }
        style.textContent = css;
      }
      const headingNode = doc.getElementById('filters-drawer-heading');
      const heading = headingNode && [...headingNode.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent.trim()).join(' ').trim();
      source = {card, label, heading, settings:JSON.parse(settings.textContent), buttons:JSON.parse(buttons.textContent)};
      apply();
    }).catch(() => { /* Native cards remain usable with the saved fallback. */ });
})();
